<script setup lang="ts">
import { computed, useSlots } from "vue"

import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
} from "@/components/ui/field"
import { cn } from "@/lib/utils"

const slots = useSlots()

const props = withDefaults(
  defineProps<{
    label?: string
    errors?: string | string[]
    message?: string
    required?: boolean
    countErrors?: number
  }>(),
  {
    countErrors: 1,
  },
)

const errorMessages = computed(() =>
  Array.isArray(props.errors)
    ? props.errors.slice(0, props.countErrors)
    : props.errors
      ? [props.errors]
      : [],
)
</script>

<template>
  <Field :class="cn('gap-1')">
    <FieldLabel :class="cn('contents')">
      <p v-if="label">
        {{ label }}<span v-if="required" class="text-destructive">*</span>
      </p>
      <slot
        v-bind="{ 'aria-invalid': errorMessages.length ? 'true' : undefined }"
      />
    </FieldLabel>

    <FieldError
      v-if="errorMessages.length"
      :errors="errorMessages.slice(0, countErrors)"
    />
    <FieldDescription v-if="message || slots.message">
      <slot name="message">{{ message }}</slot>
    </FieldDescription>
  </Field>
</template>
